<template>
  <div>
    <page-header has-return :page="pageHeaderConfig" />
    <div class="row">
      <div class="col-12">
        <filter-manager
          ref="filterRef"
          :filters="filtersConfig"
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync pr-2"
          search-text=""
          search-container-class="btn-process-custom d-flex align-items-center justify-content-end"
          v-model="filterModel"
          @search="onProcessHandler"
        >
          <div class="col d-flex justify-content-end align-items-center">
            <dropdown
              v-if="canQueue"
              icon="fas fa-print"
              :items="reportOptions"
              title="Seleccione"
            />
          </div>
        </filter-manager>
        <queue-report-status
          :queue-report="queueInfo"
          @on-cancel="cancelQueue"
          @on-download="downloadQueueReport"
        />
      </div>
    </div>
  </div>
</template>

<script>
//libs components
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import Dropdown from 'dropdown'

//services
import AcademicYearServices from '@/services/api/academicyear.api'
import RpServices from '@/services/api/rp.api.js'
import locationServices from '@/services/api/location.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js'

//constants
import codeAcademicYear from '@/utils/constants/codeAcademicYear.js'
import queueReportTypes from "@/utils/constants/queueReportTypes";
import queueReportStatus from "@/utils/constants/queueReportStatus";
import QueueReportStatus from "@/views/progress/shared/components/QueueReportStatus.vue";
import Vue from "vue";
import hubservice from "@/services/api/hub/hubservice";

export default {
  name: 'RequestInfo',
  components: {
    QueueReportStatus,
    PageHeader,
    FilterManager,
    Dropdown,
  },
  mixins: [alertMixin],
  data: () => ({
    queueInfo: null,
    filterOptions: {
      academicYears: [],
      months: [],
      centers: [],
      serviceStatuses: [],
    },
    filterModel: {
      academicYear: null,
      month: null,
      center: null,
      serviceStatus: null,
    },
  }),
  computed: {
    canQueue() {
      return this.queueInfo === null
        || this.queueInfo.statusId === queueReportStatus.Completed
        || this.queueInfo.statusId === queueReportStatus.Failed
    },
    pageHeaderConfig() {
      return {
        icon: 'fas fa-chart-pie',
        title: 'Información de Solicitudes',
        routes: ['Inicio', 'Reportes', 'Información de Solicitudes'],
      }
    },
    filtersConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Año Académico',
          clearable: false,
          class: 'col-12 col-md-4',
          options: this.filterOptions.academicYears,
          value: this.filterModel.academicYear,
          onChanged: this.onChangeAcademicYear,
        },
        {
          name: 'month',
          component: 'custom-drop-down',
          class: 'col-12 col-md-4',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Mes',
          options: this.filterOptions.months,
        },
        {
          name: 'center',
          component: 'custom-drop-down',
          class: 'col-12 col-md-4',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Centro',
          clearable: true,
          options: this.filterOptions.centers,
        },
        {
          name: 'serviceStatus',
          component: 'custom-drop-down',
          class: 'col-12 col-md-4',
          fieldKey: 'id',
          fieldName: 'name',
          placeholder: 'Estatus de Servicio',
          options: this.filterOptions.serviceStatuses,
        },
      ]
    },
    reportOptions() {
      return [
        {
          label: 'Excel',
          icon: 'fas fa-print text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.onProcessHandler(false),
        },
        {
          label: 'PDF',
          icon: 'fas fa-print text-green',
          class: 'pr-1',
          visible: true,
          click: () => this.onProcessHandler(true),
        },
      ]
    },
  },
  async mounted() {
    await this.getInitialFilters()
    const res = await ReportServices.getPreviousGeneratedReport([queueReportTypes.InformeInformacionSolicitudesExcel, queueReportTypes.InformeInformacionSolicitudesPdf])
    this.queueInfo = res.data !== '' ? res.data : null;
  },
  created() {
    Vue.use(hubservice)
    this.$userHub.$on('hub-receive-status-queue-report', this.updateReceivedQueueStatusByHub)
  },
  beforeDestroy() {
    //clean SignalR event
    this.$userHub.$off('hub-receive-status-queue-report', this.updateReceivedQueueStatusByHub)
  },
  methods: {
    async downloadQueueReport(executionLogId) {
      ReportServices.downloadQueueReport(executionLogId)
        .then((res) => DocumentServices.Download(res.data))
        .catch((err) => {
          this.ShowToast("", err.response?.data?.message, "error");
        });
    },
    async cancelQueue(executionLogId) {
      ReportServices.cancelQueueReport(executionLogId)
        .then((res) => {
          if (res.data) {
            this.ShowToast(
              'Proceso Exitoso',
              'La ejecución del reporte ha sido cancelada exitosamente.',
              'success'
            );
            this.queueInfo = null;
          }
        })
        .catch((err) => {
          this.ShowToast("", err.response?.data?.message, "error");
        });
    },
    updateReceivedQueueStatusByHub(res) {
      this.queueInfo = res.respose;
    },
    async getInitialFilters() {
      this.filterOptions.academicYears = (
        await AcademicYearServices.getAcademicYearsFromSpecificYear(
          codeAcademicYear['2016-2017']
        )
      ).data

      this.filterOptions.centers = (await locationServices.getAllCenters()).data

      this.filterOptions.serviceStatuses = (
        await RpServices.getServiceStatuses()
      ).data
    },
    async onChangeAcademicYear() {
      this.filterModel.month = null
      this.filterOptions.months = []

      await this.getMonthsInAcademicYear()
    },
    async getMonthsInAcademicYear() {
      this.filterOptions.months = (
        await AcademicYearServices.getMonthsInAcademicYear(
          this.filterModel.academicYear.id
        )
      ).data
    },
    async onProcessHandler(isPdfFormat) {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate()

      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        )
        return
      }

      ReportServices.queueReport('rprequestservice', {
        academicYearId: this.filterModel.academicYear?.id,
        month: this.filterModel.month?.id,
        centerId: this.filterModel.center?.id,
        serviceStatusId: this.filterModel.serviceStatus?.id,
        isPdfFormat,
      }).then(res => {
        this.queueInfo = {
          executionLogId: res.data,
          statusId: queueReportStatus.Pending,
          expired: false
        }
      });
    },
  },
}
</script>

<style scope>
.btn-process-custom {
  position: absolute !important;
  bottom: 17px !important;
  right: 15px !important;
}
</style>
